module.exports = __webpack_public_path__ + "static/media/ont_diagram_small.e3c0d00b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LineTest/ont_diagram_small.svg
 ** module id = 1316
 ** module chunks = 0
 **/